import _ from 'lodash';
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import AceEditor from './AceEditor';

class CodeBlock extends React.Component {
    static propTypes = {
        value: PropTypes.string.isRequired,
        language: PropTypes.string
    };

    static defaultProps = {
        language: null
    };

    shouldComponentUpdate = (nextProps) => {
        return !_.isEqual(this.props, nextProps);
    };

    render() {
        const { language, value, key, codeEditorId, fullscreenCodeWindow, setFullscreenCodeWindow, renderFullscreenToolbarElements } = this.props;

        const fullCodeEditorId = codeEditorId+key;

        return (
            <div className="block">
                <AceEditor
                    readOnly={true}
                    mode={language}
                    value={value}
                    setFullscreen={(isFullscreen) => setFullscreenCodeWindow(isFullscreen ? fullCodeEditorId : null)}
                    isFullscreen={fullscreenCodeWindow === fullCodeEditorId}
                    renderFullscreenToolbarElements={renderFullscreenToolbarElements}
                />
            </div>
        );
    }
}

export default CodeBlock;